import { ComponentName } from '@constants';
import { useAuth } from '@hooks/useAuth.tsx';
import { enableModal } from '@state/reducers/modals.ts';
import { setDisableLogoutModal, setLogout } from '@state/reducers/user.ts';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketGambleTimeReachedWatcher() {
  const { getLatest } = useSocket();
  const { signout } = useAuth();
  const dispatch = useDispatch();
  const gambleTimeReached = getLatest('player_gamble_time_reached');

  const lastEventKeyRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (gambleTimeReached) {
      // @ts-ignore
      const eventKey = `${gambleTimeReached.action}:${gambleTimeReached.data?.player_id ?? 'unknown'}`;
      if (lastEventKeyRef.current === eventKey) return;
      lastEventKeyRef.current = eventKey;
      dispatch(enableModal(ComponentName.PlayerGambleTimeReachedModal));
      signout().then(() => {
        dispatch(setLogout());
        dispatch(setDisableLogoutModal(true));
      });
    }
  }, [dispatch, gambleTimeReached, signout]);

  return null;
}
